<template>
  <div
    class="gap-x-6 gap-y-3 grid grid-cols-2 sm:gap-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-6 2xl:grid-cols-7 gap-3 whitespace">
    <div class="sm:mr-0 w-full relative cursor-pointer" v-for="item in items" :key="item.id" @click="handleClick(item)">
      <img :src="imageBaseUrl + item.picUrl" alt="城市列表" class="rounded-lg w-full aspect-square object-cover" />
      <div class="pt-3">
        <div class="flex items-center justify-between">
          <h3 class="text-sm font-semibold text-gray-800 truncate" :title="item.title">
            {{ $store.getters.isZh ? item.name : item.nameEn }}
          </h3>
        </div>
        <span class="absolute top-2 left-2 text-xs text-orange-600 bg-white px-3 py-1 rounded-full border border-gray-300">
          {{ item.type === "SIM" ? "SIM" : "eSIM" }}
        </span>
        <div class="pl-2">
          <div class="text-xs text-gray-800">{{ isZh ? item.place : item.placeEn }}</div>
        </div>
      </div>
      <van-icon
        v-if="showLiked"
        class="absolute top-2 right-2"
        :name="item.favorite ? 'like' : 'like-o'"
        :color="item.favorite ? '#ff7a00' : '#999'"
        size="28"
        @click.stop="handleFavorite(item)" />
    </div>
  </div>
</template>

<script>
import { addFavorite, removeFavorite } from "@/apis/favorite"
import { mapGetters } from "vuex"
export default {
  name: "PropertyGrid",
  props: {
    items: { type: Array, required: true },
    showLiked: { type: Boolean, required: false },
    type: { type: String, required: true },
  },
  data() {
    return {}
  },

  computed: {
    imageBaseUrl() {
      return process.env.VUE_APP_IMAGE_URL
    },
    ...mapGetters({
      isZh: "lang/isZh",
    }),
  },
  methods: {
    async handleFavorite(item) {
      try {
        if (item.favorite) {
          await removeFavorite({ spuId: item.id })
          this.$emit("updateFavorite", item.id, false)
        } else {
          await addFavorite({ spuId: item.id })
          this.$emit("updateFavorite", item.id, true)
        }
      } catch (error) {
        console.log("object :>> ", error)
      }
    },
    handleClick(item) {
      this.$router.push({ name: "productDetail", query: { id: item.id, type: item.type, place: this.isZh ? item.place : item.placeEn } })
    },
  },
}
</script>

<style scoped></style>
